"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _en;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExternalActionErrorMessageForEndTag = exports.EMeteorActionErrorTag = void 0;
var EMeteorActionErrorTag;
(function (EMeteorActionErrorTag) {
  EMeteorActionErrorTag["NEW_ACTION_STARTED"] = "NEW_ACTION_STARTED";
  EMeteorActionErrorTag["INCOMPLETE_ACTION"] = "INCOMPLETE_ACTION";
  EMeteorActionErrorTag["NO_ACCOUNTS"] = "NO_ACCOUNTS";
  EMeteorActionErrorTag["WINDOW_CLOSED"] = "WINDOW_CLOSED";
  EMeteorActionErrorTag["USER_CANCELLED"] = "USER_CANCELLED";
  EMeteorActionErrorTag["POPUP_WINDOW_REFUSED"] = "POPUP_WINDOW_REFUSED";
  EMeteorActionErrorTag["POPUP_WINDOW_OPEN_FAILED"] = "POPUP_WINDOW_OPEN_FAILED";
})(EMeteorActionErrorTag = exports.EMeteorActionErrorTag || (exports.EMeteorActionErrorTag = {}));
var en = (_en = {}, _defineProperty(_en, EMeteorActionErrorTag.WINDOW_CLOSED, "User closed the window"), _defineProperty(_en, EMeteorActionErrorTag.INCOMPLETE_ACTION, "User didn't complete the action"), _defineProperty(_en, EMeteorActionErrorTag.NEW_ACTION_STARTED, "A new action was started by the user, old action failed"), _defineProperty(_en, EMeteorActionErrorTag.POPUP_WINDOW_OPEN_FAILED, "Popup window failed to open"), _defineProperty(_en, EMeteorActionErrorTag.POPUP_WINDOW_REFUSED, "User refused to allow the popup window to open"), _defineProperty(_en, EMeteorActionErrorTag.USER_CANCELLED, "User cancelled the action"), _defineProperty(_en, EMeteorActionErrorTag.NO_ACCOUNTS, "No Meteor account found- try again after creating one"), _en);
function getExternalActionErrorMessageForEndTag(tag) {
  var _a;
  return (_a = en[tag]) !== null && _a !== void 0 ? _a : "An unknown error occurred";
}
exports.getExternalActionErrorMessageForEndTag = getExternalActionErrorMessageForEndTag;